import { Axios } from "axios";
import { CherryPayApi } from "./models";
import { ApiResult, apiResult } from "./apiClient";

export type ResendEmailRequestType = "membership" | "renewal";

const resendEmailUrl = (
  requestType: ResendEmailRequestType,
  businessId: string,
  sessionId: string
) =>
  `cherrypay/v1/${businessId}/odma/${
    requestType === "membership"
      ? "membership-requests"
      : "membership-renewal-requests"
  }/${sessionId}/resend-confirmation-email`;

/** ODMA Membership Request / Membership Renewal Request actions. */
export class MembershipRequestApiClient {
  private cherryPayClient: Axios;

  constructor(cherryPayClient: Axios) {
    this.cherryPayClient = cherryPayClient;
  }

  /** Returns the member emails that can be resent for a request (with why any can't be), and the email address on file. */
  async getResendEmailOptions(
    requestType: ResendEmailRequestType,
    businessId: string,
    sessionId: string
  ): Promise<ApiResult<CherryPayApi.ResendEmailOptions>> {
    const result = await this.cherryPayClient.get(
      resendEmailUrl(requestType, businessId, sessionId)
    );
    return apiResult<CherryPayApi.ResendEmailOptions>(result);
  }

  /** Resends one member email for a request. */
  async resendEmail(
    requestType: ResendEmailRequestType,
    businessId: string,
    sessionId: string,
    emailType: CherryPayApi.ResendEmailType,
    emailAddress: string
  ): Promise<ApiResult<boolean>> {
    const body: CherryPayApi.ResendEmailRequest = {
      EmailType: emailType,
      EmailAddress: emailAddress,
    };
    const result = await this.cherryPayClient.post(
      resendEmailUrl(requestType, businessId, sessionId),
      body
    );
    return apiResult<boolean>(result);
  }
}
